import { render } from "./CreationModificationCoupon.vue?vue&type=template&id=38cec00c&scoped=true&ts=true"
import script from "./CreationModificationCoupon.vue?vue&type=script&lang=ts"
export * from "./CreationModificationCoupon.vue?vue&type=script&lang=ts"

import "./CreationModificationCoupon.vue?vue&type=style&index=0&id=38cec00c&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cec00c"]])

export default __exports__